import { dataLoading } from "@/shared/decorators/LoadingAction.decorator";
import apiClient from "./ApiClientService";
import { CountryRegionDomain } from "@/shared/models/CountryRegionDomain";

export class CountryRegionDomainApi {
  @dataLoading([])
  static async getAll(): Promise<CountryRegionDomain[]> {
    const result = await apiClient.get("common/countryregiondomains");
    if (result.status === 200 && result.data) {
      return result.data as CountryRegionDomain[];
    }
    return [];
  }

  static async create(data: CountryRegionDomain): Promise<boolean> {
    const result = await apiClient.post("countryregiondomains", data);
    return result.status === 200 || result.status === 201;
  }

  static async update(data: CountryRegionDomain): Promise<boolean> {
    const result = await apiClient.put(`countryregiondomains`, data);
    return result.status === 200;
  }

  static async remove(id: number): Promise<boolean> {
    const result = await apiClient.delete(`countryregiondomains/${id}`);
    return result.status === 200 || result.status === 204;
  }
}
